import React from 'react';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import { useTranslation } from 'react-i18next';
import LooksOneIcon from '@mui/icons-material/LooksOne';
import LooksTwoIcon from '@mui/icons-material/LooksTwo';
import FormatBoldIcon from '@mui/icons-material/FormatBold';
import FormatItalicIcon from '@mui/icons-material/FormatItalic';
import FormatUnderlinedIcon from '@mui/icons-material/FormatUnderlined';
import CodeIcon from '@mui/icons-material/Code';
import FormatListBulletedRoundedIcon from '@mui/icons-material/FormatListBulletedRounded';
import FormatListNumberedRoundedIcon from '@mui/icons-material/FormatListNumberedRounded';
import FormatAlignLeftRoundedIcon from '@mui/icons-material/FormatAlignLeftRounded';
import FormatAlignRightRoundedIcon from '@mui/icons-material/FormatAlignRightRounded';
import FormatAlignCenterRoundedIcon from '@mui/icons-material/FormatAlignCenterRounded';
import FormatAlignJustifyRoundedIcon from '@mui/icons-material/FormatAlignJustifyRounded';

/* ---------------- Toolbar ---------------- */

const CustomToolbar = () => (
    <div id="toolbar">
        {/* Text formatting */}
        <span className="ql-formats">
            <button className="ql-bold"><FormatBoldIcon /></button>
            <button className="ql-italic"><FormatItalicIcon /></button>
            <button className="ql-underline"><FormatUnderlinedIcon /></button>
            <button className="ql-code"><CodeIcon /></button>
        </span>

        {/* Headings */}
        <span className="ql-formats">
            <button className="ql-header" value="1"><LooksOneIcon /></button>
            <button className="ql-header" value="2"><LooksTwoIcon /></button>
        </span>

        {/* Lists */}
        <span className="ql-formats">
            <button className="ql-list" value="ordered">
                <FormatListNumberedRoundedIcon />
            </button>
            <button className="ql-list" value="bullet">
                <FormatListBulletedRoundedIcon />
            </button>
        </span>

        {/* Alignment */}
        <span className="ql-formats">
            <button className="ql-align" value="">
                <FormatAlignLeftRoundedIcon />
            </button>
            <button className="ql-align" value="center">
                <FormatAlignCenterRoundedIcon />
            </button>
            <button className="ql-align" value="right">
                <FormatAlignRightRoundedIcon />
            </button>
            <button className="ql-align" value="justify">
                <FormatAlignJustifyRoundedIcon />
            </button>
        </span>

        {/* ✅ Text Color & Background Color */}
        <span className="ql-formats">
            <select className="ql-color" />
            <select className="ql-background" />
        </span>
    </div>
);

/* ---------------- Editor ---------------- */

const DescriptionField = ({ value, onChange }) => {
    const { t: tCommon } = useTranslation('common');


    const modules = {
        toolbar: {
            container: '#toolbar',
        },
    };

    const formats = [
        'header',
        'bold',
        'italic',
        'underline',
        'code',
        'list',
        'bullet',
        'align',
        'color',
        'background',
    ];

    /* ---------------- CSS Fixes ---------------- */

    const quillOverrideStyles = `
        .ql-toolbar button {
            width: 32px !important;
            height: 32px !important;
            display: flex !important;
            align-items: center;
            justify-content: center;
        }

        .ql-toolbar button svg {
            font-size: 20px;
        }

        /* Fix invisible lists caused by global CSS */
        .ql-editor ol,
        .ql-editor ul {
            padding-left: 1.5em !important;
        }

        .ql-editor li {
            list-style-type: inherit !important;
        }

        /* Color picker sizing */
        .ql-toolbar .ql-color,
        .ql-toolbar .ql-background {
            width: 32px;
            height: 32px;
        }
    `;

    return (
        <div>
            <style>{quillOverrideStyles}</style>

            <CustomToolbar />

            <ReactQuill
                theme="snow"
                value={value || ''}
                onChange={onChange}
                modules={modules}
                formats={formats}
                placeholder={tCommon('Product Description')}
            />
        </div>
    );
};

export default DescriptionField;